"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.KermanSocialMoneyFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var KermanSocialMoneyFactory = /** @class */ (function (_super) {
    __extends(KermanSocialMoneyFactory, _super);
    function KermanSocialMoneyFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    KermanSocialMoneyFactory.prototype.deploy = function (_name, _symbol, _decimals, _proportions, _vestingBeneficiary, _platformWallet, _tokenVestingInstance, overrides) {
        return _super.prototype.deploy.call(this, _name, _symbol, _decimals, _proportions, _vestingBeneficiary, _platformWallet, _tokenVestingInstance, overrides || {});
    };
    KermanSocialMoneyFactory.prototype.getDeployTransaction = function (_name, _symbol, _decimals, _proportions, _vestingBeneficiary, _platformWallet, _tokenVestingInstance, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _name, _symbol, _decimals, _proportions, _vestingBeneficiary, _platformWallet, _tokenVestingInstance, overrides || {});
    };
    KermanSocialMoneyFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    KermanSocialMoneyFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    KermanSocialMoneyFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return KermanSocialMoneyFactory;
}(contracts_1.ContractFactory));
exports.KermanSocialMoneyFactory = KermanSocialMoneyFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "_decimals",
                type: "uint8",
            },
            {
                internalType: "uint256[3]",
                name: "_proportions",
                type: "uint256[3]",
            },
            {
                internalType: "address",
                name: "_vestingBeneficiary",
                type: "address",
            },
            {
                internalType: "address",
                name: "_platformWallet",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tokenVestingInstance",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burnFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x60806040523480156200001157600080fd5b50604051620010133803806200101383398101604081905262000034916200035a565b8651620000499060039060208a019062000206565b5085516200005f90600490602089019062000206565b506005805460ff191660ff8716179055604084015160208501518551600092916200008a91620004b8565b620000969190620004b8565b9050620000ac848660005b6020020151620000f6565b620000ba83866001620000a1565b620000c882866002620000a1565b6002548114620000e857634e487b7160e01b600052600160045260246000fd5b505050505050505062000530565b6001600160a01b0382166200012b5760405162461bcd60e51b8152602060048201526000602482015260440160405180910390fd5b6200014781600254620001cf60201b620007041790919060201c565b6002556001600160a01b038216600090815260208181526040909120546200017a91839062000704620001cf821b17901c565b6001600160a01b038316600081815260208181526040808320949094559251848152919290917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef910160405180910390a35050565b600080620001de8385620004b8565b905083811015620001ff57634e487b7160e01b600052600160045260246000fd5b9392505050565b8280546200021490620004dd565b90600052602060002090601f01602090048101928262000238576000855562000283565b82601f106200025357805160ff191683800117855562000283565b8280016001018555821562000283579182015b828111156200028357825182559160200191906001019062000266565b506200029192915062000295565b5090565b5b8082111562000291576000815560010162000296565b80516001600160a01b0381168114620002c457600080fd5b919050565b600082601f830112620002da578081fd5b81516001600160401b03811115620002f657620002f66200051a565b60206200030c601f8301601f1916820162000485565b828152858284870101111562000320578384fd5b835b838110156200033f57858101830151828201840152820162000322565b838111156200035057848385840101525b5095945050505050565b6000806000806000806000610120888a03121562000376578283fd5b87516001600160401b03808211156200038d578485fd5b6200039b8b838c01620002c9565b985060209150818a015181811115620003b2578586fd5b620003c08c828d01620002c9565b98505060408a015160ff81168114620003d7578586fd5b9650607f8a018b13620003e8578485fd5b6040516060810181811083821117156200040657620004066200051a565b60405290508060608b0160c08c018d81111562000421578788fd5b875b6003811015620004425782518552938501939185019160010162000423565b508298506200045181620002ac565b975050505050506200046660e08901620002ac565b9150620004776101008901620002ac565b905092959891949750929550565b604051601f8201601f191681016001600160401b0381118282101715620004b057620004b06200051a565b604052919050565b60008219821115620004d857634e487b7160e01b81526011600452602481fd5b500190565b600181811c90821680620004f257607f821691505b602082108114156200051457634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052604160045260246000fd5b610ad380620005406000396000f3fe608060405234801561001057600080fd5b50600436106100b45760003560e01c806370a082311161007157806370a082311461015157806379cc67901461017a57806395d89b411461018f578063a457c2d714610197578063a9059cbb146101aa578063dd62ed3e146101bd57600080fd5b806306fdde03146100b9578063095ea7b3146100d757806318160ddd146100fa57806323b872dd1461010c578063313ce5671461011f578063395093511461013e575b600080fd5b6100c16101f6565b6040516100ce91906109ca565b60405180910390f35b6100ea6100e53660046109a1565b610284565b60405190151581526020016100ce565b6002545b6040519081526020016100ce565b6100ea61011a366004610966565b610320565b60055461012c9060ff1681565b60405160ff90911681526020016100ce565b6100ea61014c3660046109a1565b6104d5565b6100fe61015f36600461091a565b6001600160a01b031660009081526020819052604090205490565b61018d6101883660046109a1565b61058c565b005b6100c161059a565b6100ea6101a53660046109a1565b6105a7565b6100ea6101b83660046109a1565b610607565b6100fe6101cb366004610934565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b6003805461020390610a4c565b80601f016020809104026020016040519081016040528092919081815260200182805461022f90610a4c565b801561027c5780601f106102515761010080835404028352916020019161027c565b820191906000526020600020905b81548152906001019060200180831161025f57829003601f168201915b505050505081565b60006001600160a01b0383166102bb5760405162461bcd60e51b815260206004820152600060248201526044015b60405180910390fd5b3360008181526001602090815260408083206001600160a01b03881680855290835292819020869055518581529192917f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92591015b60405180910390a350600192915050565b6001600160a01b0383166000908152602081905260408120548211156103625760405162461bcd60e51b815260206004820152600060248201526044016102b2565b6001600160a01b03841660009081526001602090815260408083203384529091529020548211156103af5760405162461bcd60e51b815260206004820152600060248201526044016102b2565b6001600160a01b0383166103df5760405162461bcd60e51b815260206004820152600060248201526044016102b2565b6001600160a01b0384166000908152602081905260409020546104029083610738565b6001600160a01b0380861660009081526020819052604080822093909355908516815220546104319083610704565b6001600160a01b0380851660009081526020818152604080832094909455918716815260018252828120338252909152205461046d9083610738565b6001600160a01b03858116600081815260016020908152604080832033845282529182902094909455518581529186169290917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef910160405180910390a35060019392505050565b60006001600160a01b0383166105075760405162461bcd60e51b815260206004820152600060248201526044016102b2565b3360009081526001602090815260408083206001600160a01b03871684529091529020546105359083610704565b3360008181526001602090815260408083206001600160a01b038916808552908352928190208590555193845290927f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925910161030f565b6105968282610762565b5050565b6004805461020390610a4c565b60006001600160a01b0383166105d95760405162461bcd60e51b815260206004820152600060248201526044016102b2565b3360009081526001602090815260408083206001600160a01b03871684529091529020546105359083610738565b336000908152602081905260408120548211156106405760405162461bcd60e51b815260206004820152600060248201526044016102b2565b6001600160a01b0383166106705760405162461bcd60e51b815260206004820152600060248201526044016102b2565b3360009081526020819052604090205461068a9083610738565b33600090815260208190526040808220929092556001600160a01b038516815220546106b69083610704565b6001600160a01b038416600081815260208181526040918290209390935551848152909133917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef910161030f565b6000806107118385610a1d565b90508381101561073157634e487b7160e01b600052600160045260246000fd5b9392505050565b60008282111561075857634e487b7160e01b600052600160045260246000fd5b6107318284610a35565b6001600160a01b03821660009081526001602090815260408083203384529091529020548111156107af5760405162461bcd60e51b815260206004820152600060248201526044016102b2565b6001600160a01b03821660009081526001602090815260408083203384529091529020546107dd9082610738565b6001600160a01b038316600090815260016020908152604080832033845290915290205561059682826001600160a01b0382166108365760405162461bcd60e51b815260206004820152600060248201526044016102b2565b6001600160a01b0382166000908152602081905260409020548111156108785760405162461bcd60e51b815260206004820152600060248201526044016102b2565b6002546108859082610738565b6002556001600160a01b0382166000908152602081905260409020546108ab9082610738565b6001600160a01b03831660008181526020818152604080832094909455925184815290927fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef910160405180910390a35050565b80356001600160a01b038116811461091557600080fd5b919050565b60006020828403121561092b578081fd5b610731826108fe565b60008060408385031215610946578081fd5b61094f836108fe565b915061095d602084016108fe565b90509250929050565b60008060006060848603121561097a578081fd5b610983846108fe565b9250610991602085016108fe565b9150604084013590509250925092565b600080604083850312156109b3578182fd5b6109bc836108fe565b946020939093013593505050565b6000602080835283518082850152825b818110156109f6578581018301518582016040015282016109da565b81811115610a075783604083870101525b50601f01601f1916929092016040019392505050565b60008219821115610a3057610a30610a87565b500190565b600082821015610a4757610a47610a87565b500390565b600181811c90821680610a6057607f821691505b60208210811415610a8157634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052601160045260246000fdfea2646970667358221220cbee9115c7e33e779826fbb80359846c94898c61ab192bef2cfbddc3fb6af02564736f6c63430008040033";
